<template>
  <div class="room-attendance-mobile-list-component">
    <div class="room-attendance-mobile-list-wrapper">
      <ul class="room-attendance-mobile-list">
        <li v-for="(attendance, i) in attendanceList" :key="i" class="room-attendance-mobile-item" :class="{ isOpen: openUserList.includes(i) }">
          <div class="room-attendance-mobile-item-header" @click="toggleUserInfo(i)">
            <p class="room-attendance-mobile-item-title" :class="{ me: attendance.userId === me.userId }">{{ attendance.nickname || attendance.username }}</p>
            <div class="room-attendance-mobile-item-button-container">
              <div v-if="attendance.present" class="room-attendance-mobile-item-button join-status" />
              <button class="room-attendance-mobile-item-button toggle-switch"></button>
            </div>
          </div>
          <div class="room-attendance-mobile-item-body">
            <div class="room-attendance-mobile-item-body-item">
              <p class="room-attendance-mobile-item-body-item-title">{{ $t("attendance.list.init") }}</p>
              <p class="room-attendance-mobile-item-body-item-value">{{ getFormedDate(attendance.firstEnter) }}</p>
            </div>
            <div class="room-attendance-mobile-item-body-item">
              <p class="room-attendance-mobile-item-body-item-title">{{ $t("attendance.list.last") }}</p>
              <p class="room-attendance-mobile-item-body-item-value">{{ !attendance.lastLeave ? '-' : getFormedDate(attendance.lastLeave) }}</p>
            </div>
            <div class="room-attendance-mobile-item-body-item">
              <p class="room-attendance-mobile-item-body-item-title">{{ $t("attendance.list.total") }}</p>
              <p class="room-attendance-mobile-item-body-item-value">{{ getDurationDate(attendance.totalAttendingSeconds) }}</p>
            </div>
            <div class="room-attendance-mobile-item-body-item">
              <p class="room-attendance-mobile-item-body-item-title">{{ $t("attendance.list.kickCount") }}</p>
              <p class="room-attendance-mobile-item-body-item-value">{{ attendance.kickCount }}</p>
            </div>
            <div class="room-attendance-mobile-item-body-item">
              <p class="room-attendance-mobile-item-body-item-title">Email</p>
              <p class="room-attendance-mobile-item-body-item-value">{{ attendance.email || $t('attendance.modal.nonMember')}}</p>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment/moment";

export default {
  name: 'RoomAttendanceMobileList',
  props: {
    attendanceList: { type: Array,  default: () => [],  required: true },
  },
  data() {
    return {
      openUserList: [],
    }
  },
  computed: {
    ...mapGetters('user', [
      'me',
    ]),
    getFormedDate() {
      return date => {
        return date && moment(date).format('YY-MM-DD HH:mm:ss');
      }
    },
    getDurationDate() {
      return sec => {
        let min = 0;
        let hours = 0;

        if(sec) {
          min = parseInt(sec/60);
          hours = parseInt(min/60);
          min %= 60;
          sec %= 60;
        }

        return `${hours}:${(min<10 ? '0':'').concat(min)}:${(sec<10 ? '0':'').concat(sec)}`;
      }
    },
  },
  methods: {
    toggleUserInfo(index) {
      this.openUserList = this.openUserList.includes(index) ? this.openUserList.filter(id => id !== index) : [...this.openUserList, index];
    }
  }
}
</script>

<style lang="scss" scoped>
.room-attendance-mobile-list-component {}
.room-attendance-mobile-list-wrapper {}
.room-attendance-mobile-list {}
.room-attendance-mobile-item {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  &:first-child {
    border-top: none;
  }
  &.isOpen {
    .room-attendance-mobile-item-button {
      &.toggle-switch {
        transform: rotate(180deg);
      }
    }
    .room-attendance-mobile-item-body {
      display: block;
    }
  }
}
.room-attendance-mobile-item-header {
  height: 56px;
  padding-left: 20px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.room-attendance-mobile-item-title {
  &.me {
    color: $mainColor;
  }
}
.room-attendance-mobile-item-button-container {
  height: 100%;
  display: flex;
}
.room-attendance-mobile-item-button {
  width: 50px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  &.join-status {
    &::before {
      content: '';
      width: 10px;
      height: 10px;
      border-radius: 100%;
      background-color: #15c796;
    }
  }
  &.toggle-switch {
    background: url('~@/assets/images/arrowLineThickDown.svg') no-repeat center / 18px auto;
  }
}
.room-attendance-mobile-item-body {
  padding: 20px;
  background-color: #fafafa;
  display: none;
}
.room-attendance-mobile-item-body-item {
  margin-top: 16px;
  display: flex;
  align-items: center;
  &:first-of-type {
    margin-top: 0;
  }
}
.room-attendance-mobile-item-body-item-title {
  width: 100px;
  font-size: 13px;
  color: #999;
}
.room-attendance-mobile-item-body-item-value {
  font-size: 13px;
  font-weight: 300;
  color: #666;
}
</style>
